var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mku-collapse-transition",
    { attrs: { animte: "ease", duration: 0.3 } },
    [
      _vm.isShow
        ? _c("div", { class: _vm.alertClassNames }, [
            _c(
              "div",
              { staticClass: "mku-alert-wrapper" },
              [
                _vm.showIcon
                  ? _c("mku-icon", {
                      attrs: {
                        "class-name": "mku-alert__icon",
                        size: "26px",
                        type: _vm.iconName
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "mku-alert__content" }, [
                  _c(
                    "h3",
                    { staticClass: "mku-alert__title mku-global-ellipsis" },
                    [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]
                  ),
                  _vm._v(" "),
                  _vm.content
                    ? _c(
                        "p",
                        {
                          staticClass: "mku-alert__desc",
                          style: _vm.contentStyle
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(_vm.content) + "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.closeable
                  ? _c("mku-icon", {
                      attrs: {
                        "class-name": "mku-alert__close",
                        type: "close",
                        size: "20px"
                      },
                      on: { click: _vm.handleClose }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }